import { useQuery } from '@tanstack/vue-query'
import { getRentalDistributionCounts } from '../rentalDistributionsEndpoints'
import { rentalDistributionKeys } from '../rentalDistributionsQueryKeys'

const COUNTS_STALE_MS = 30_000

/**
 * Backs the KPI strip and the sidebar badge. Exported from the module surface
 * because AppSidebar consumes it — see index.ts.
 */
export function useRentalDistributionCountsQuery() {
  return useQuery({
    queryKey: rentalDistributionKeys.counts(),
    queryFn: () => getRentalDistributionCounts(),
    staleTime: COUNTS_STALE_MS,
  })
}
